namespace('compass.util');

(function(undefined) {
/// @function               convertHexToHSL( hex )
/// @desc                   Takes a hex string & finds the corresponding HSV values
/// @param {string} hex     the hex string to input for formatting
/// @returns {object}
function convertHexToHSL(hex) {
	var r = parseInt(hex[1] + hex[2], 16) / 255;
	var g = parseInt(hex[3] + hex[4], 16) / 255;
	var b = parseInt(hex[5] + hex[6], 16) / 255;

	var cmin = Math.min(r,g,b);
	var cmax = Math.max(r,g,b);
	var delta = cmax - cmin;
	var h, s, l;

	if (delta === 0) {
		h = 0;
	} else if (cmax === r) {
		h = ((g - b) / delta) % 6;
	} else if (cmax === g) {
		h = (b - r) / delta + 2;
	} else {
		h = (r - g) / delta + 4;
	}
	h = (360 + Math.round(h * 60)) % 360;

	l = (cmax + cmin) / 2;
	s = (delta === 0) ? 0 : delta / (1 - Math.abs(2 * l - 1));
	s = (s * 100).toFixed(1);
	l = (l * 100).toFixed(1);

	return {
		h: h,
		s: s,
		l: l
	};
}

/// @function               formatHexString( hex )
/// @desc                   Formats a given hex string to fit the format of #0a0a0a
/// @param {string} hex     the hex string to input for formatting
/// @returns {string}
function formatHexString(hx) {
	var code = hx.replace('#', '');
	if (code.length == 3) {
		code = code[0] + code[0] +  code[1] + code[1] + code[2] + code[2];
	}
	return '#' + code.slice(0, 6);
}

/// @function               setCustomHSLByHex( name, hex )
/// @desc                   Sets the HSL components for a custom CSS HSL property.
/// @param {string} name    the name of the HSL property
/// @param {string} hex     the 7-character hex string to use (formatted `#0a0a0a`)
function setCustomHSLByHex(name, hx) {
	/* This function is intended to be used alongside CSS variables defined in
	** The stylesheets themselves, where individual components are combined
	** in real-time to create an HSL color, like this:
	**
	**	 :root {
	**		 --customColor: hsl(var(--customColor_H), var(--customColor_S), var(--customColor_L)); 
	**	 }
	**
	** The individual `*_H` / `*_S` / `*_L` values should NOT be predefined, as this
	** interferes with fallback behavior on browsers lacking CSS variable support.
	*/
	var hsl = convertHexToHSL(formatHexString(hx));
	document.documentElement.style.setProperty('--' + name + '_H', hsl.h);
	document.documentElement.style.setProperty('--' + name + '_S', hsl.s + '%');
	document.documentElement.style.setProperty('--' + name + '_L', hsl.l + '%');
}

/* export functions */
compass.util.css = {
	formatHexString   : formatHexString,
	convertHexToHSL   : convertHexToHSL,
	setCustomHSLByHex : setCustomHSLByHex,
};
})();

